/* eslint-disable  */
import { Delete } from '@material-ui/icons'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import { authActionCreators, messagesActionCreators } from '../../../service/action-creators'
import axiosInstance from '../../../service/axios/axios'
import './Conversation.css'
import {RiDeleteBin2Line} from 'react-icons/ri'

function Conversation({conversation}) {
    const dispatch = useDispatch()
    const [user, setUser] = useState(null)
    const {getUserById} = bindActionCreators(authActionCreators, dispatch)
    const {GetConversations, DeleteConversations, ResetMessagesResponse} = bindActionCreators(messagesActionCreators, dispatch)
    const auth = useSelector(state => state?.auth)
    const [active, setActive] = useState(false)
    const chat = useSelector((state) => state.messages);
    const { response } = chat;

    // MembersMessages docs have a `reference` field but no `members` array
    const isMembersMessages = !conversation?.members && conversation?.reference !== undefined;

    useEffect(() => {
        if (isMembersMessages) return; // No user to fetch for MembersMessages
        const otherUser = conversation?.members?.find(u => u !== auth?.user?._id)
        if (!otherUser) return;
        const getUser = async () => {
            try {
              const res = await axiosInstance.get(`/users/user?user_id=${otherUser}`)
              setUser(res.data)
            } catch (error) {
                console.log('error', error)
            }
        }
        getUser()
    },[auth?.user, conversation])

    useEffect(() => {
      GetConversations(auth?.user?._id);
    }, [])

    useEffect(() => {
      if (response?.state === "SUCCESS") {
        setTimeout(() => {
          ResetMessagesResponse();
          GetConversations(auth?.user?._id);
        }, 1500);
      } else if (response?.state === "ERROR") {
        setTimeout(() => {
          ResetMessagesResponse();
        }, 1500);
      }
    }, [response?.state]);

  return (
    <div className={"Conversation"} onClick={() => {
      if(conversation){
        setActive(true)
      }else{
        setActive(false)
      }
    }}>
        <div className='userProfile'>
        <img
          className='conversationImage'
          src={
            isMembersMessages
              ? '/images/dev/user.png'
              : (user?.profile_image ?? '/images/dev/user.png')
          }
          alt="officer"
        />
        <div>
          <div className='title'>
            {isMembersMessages ? (conversation?.subject || conversation?.system_user) : conversation?.title}
          </div>
          <div className='username'>
            {isMembersMessages ? conversation?.system_user : user?.name}
          </div>
          <div className='user'>
            {isMembersMessages ? '' : user?.officer}
          </div>
        </div>
        </div>
        <RiDeleteBin2Line onClick={() => DeleteConversations(conversation?._id)}/>
    </div>
  )
}

export default Conversation
